export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Content Creator",
    avatar: "SM",
    content: "Working with Eshwald Ops transformed my creator business. They handle everything behind the scenes while I focus on creating content. My revenue increased 3x in just 4 months.",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Chen",
    role: "YouTube Educator",
    avatar: "MC",
    content: "Finally, a partnership that actually works. No upfront costs, professional product packaging, and consistent income. Eshwald Ops is the real deal.",
    rating: 5
  },
  {
    id: 3,
    name: "Jessica Torres",
    role: "Lifestyle Influencer",
    avatar: "JT",
    content: "I was struggling to monetize beyond brand deals. Eshwald Ops helped me launch digital products that my audience loves. Game changer!",
    rating: 5
  }
];

export const features = [
  {
    id: 1,
    icon: "Sparkles",
    title: "Zero Upfront Cost",
    description: "We invest in you first. No financial risk on your end — we only succeed when you do."
  },
  {
    id: 2,
    icon: "Package",
    title: "Full Product Creation",
    description: "From ideation to packaging, we create premium digital products tailored to your audience."
  },
  {
    id: 3,
    icon: "TrendingUp",
    title: "Strategic Launch Support",
    description: "Expert-designed product launches that convert. We handle the strategy while you stay authentic."
  },
  {
    id: 4,
    icon: "Shield",
    title: "Behind-the-Scenes Management",
    description: "We manage all backend operations — customer service, fulfillment, and business logistics."
  },
  {
    id: 5,
    icon: "Users",
    title: "You Stay the Face",
    description: "Your brand, your voice. We empower you without overshadowing your creator identity."
  },
  {
    id: 6,
    icon: "Wallet",
    title: "Consistent Revenue Stream",
    description: "Move beyond sporadic brand deals to predictable, scalable income from your audience."
  }
];